import React, { FC } from 'react';
import { DocumentGroup } from '../../../../interfaces/DocumentGroup';
import { StyledSection, StyledT } from './DocumentListGroup.styles';
import DocumentListItem from './DocumentListItem';
import getGroupedContractsPeriodIsDisplayable from './GroupedContracts/GroupedContract/getGroupedContractsPeriodIsDisplayable';
import GroupedContracts from './GroupedContracts/GroupedContracts';
import getDocumentsInSameGroup from './GroupedContracts/GroupedContract/getDocumentsInSameGroup';

export interface DocumentListGroupProps {
  group: DocumentGroup;
  groups: DocumentGroup[];
}

const DocumentListGroup: FC<DocumentListGroupProps> = ({ group, groups }) => {
  if (!getGroupedContractsPeriodIsDisplayable(group, groups)) return null;
  return (
    <StyledSection>
      <StyledT>{group.period}</StyledT>
      {group.documents.filter((d) => !d.grouped || getDocumentsInSameGroup(d, groups.flatMap((x) => x.documents)).length === 0).map((d) =>
        <DocumentListItem key={d.id} document={d}></DocumentListItem>)}
      <GroupedContracts group={group} />
    </StyledSection>
  );
};

export default DocumentListGroup;
